import Vue from 'vue'
import VueRouter from 'vue-router'
import { ZodValidationPlugin } from '@/lib/validation'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import advanced from 'dayjs/plugin/advancedFormat'
import VueCookies from 'vue-cookies'
import { createPinia, PiniaVuePlugin } from 'pinia'

import App from '@app/App.vue'
import SurveySwitcher from '@survey/pages/SurveySwitcher.vue'
import SurveyMultiStep from '@survey/pages/SurveyMultiStep.vue'
import SurveyForm from '@survey/pages/SurveyForm.vue'
import WebLinkSurveyPage from '@survey/pages/WebLinkSurvey.vue'
import WeblinkThanks from '@survey/pages/WeblinkThanks.vue'
import RecipientResponses from '@survey/pages/RecipientResponses.vue'
import UeBaseComponents from '@/vue_plugins/UeBaseComponents'

import * as api from '@app/api'

import SurveyComplete from '@survey/pages/SurveyComplete.vue'
import SurveyCompleteWrapper from '@survey/pages/SurveyCompleteWrapper.vue'

import ContentAssetRaw from '@survey/pages/content_assets/Raw.vue'
import VariantRaw from '@survey/pages/variants/Raw.vue'

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(ZodValidationPlugin, { inject: false })
Vue.use(VueCookies)
Vue.use(PiniaVuePlugin)
Vue.use(UeBaseComponents)

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advanced)

Vue.filter('dayjs', (date, format) => {
  return dayjs(date).format(format)
})

import { BootstrapVue } from 'bootstrap-vue'

const routes = [
  { path: '/campaigns/complete', component: SurveyComplete, props: true },
  { path: '/campaigns/thanks', component: WeblinkThanks, props: true },
  { path: '/campaigns/:recipientToken', component: SurveySwitcher, props: true },
  {
    path: '/campaigns/:survey_token/share',
    component: WebLinkSurveyPage,
    props: true,
  },
  {
    name: 'one-question-at-a-time',
    path: '/surveys/:recipientToken/one_question_at_a_time',
    component: SurveyMultiStep,
    props: true,
  },
  {
    path: '/surveys/:recipientToken/complete',
    component: SurveyCompleteWrapper,
    props: true,
  },
  { path: '/surveys/thanks', component: WeblinkThanks, props: true },
  { path: '/surveys/:recipientToken', component: SurveySwitcher, props: true },
  {
    path: '/surveys/:surveyToken/preview',
    component: SurveyForm,
    props: { preview: true },
  },
  {
    path: '/surveys/:survey_token/share',
    component: WebLinkSurveyPage,
    props: true,
  },
  {
    path: '/content_assets/:content_asset_id/raw',
    component: ContentAssetRaw,
    props: (route) => ({ ...route.query, ...route.params }),
  },
  // Should these two routes live in this pack? Or should they move to app.js?
  { path: '/variants/:variant_id/raw/', component: VariantRaw, props: true },
  { path: '/recipients/:token/responses', component: RecipientResponses, props: true },
]

const pinia = createPinia()
pinia.use(() => ({ api }))

const router = new VueRouter({
  mode: 'history',
  routes: routes,
})

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    router,
    pinia,
    render: (h) => h(App),
  }).$mount('#site')
})
